// @flow
import * as React from 'react';
import styled from 'styled-components';
import ChevronIcon from 'chevron-down.svg';

export const ChevronDownIcon = (props: any) => (
  <ChevronIcon width="15" height="9" {...props} />
);

export const ChevronUpIcon = styled(ChevronDownIcon)`
  transform: rotate(180deg);
`;

export const ChevronLeftIcon = styled(ChevronDownIcon)`
  transform: rotate(90deg);
`;
export const ChevronRightIcon = styled(ChevronDownIcon)`
  transform: rotate(-90deg);
`;
